export default __webpack_public_path__ + "static/media/grafema_capitolio_02.8ade3824.jpg";